import { isDefined } from "@clipboard-health/util-ts";
import { base64ToBlob } from "@src/appV2/lib/files";
import { useUpdateShiftTimecard } from "@src/appV2/redesign/WorkerShifts/UnverifiedShifts/UploadTimesheet/useUpdateShiftTimecard";
import { useUploadShiftTimecardToS3 } from "@src/appV2/redesign/WorkerShifts/UnverifiedShifts/UploadTimesheet/useUploadShiftTimecardToS3";
import { useCallback } from "react";

interface UseNonInstantPayTimesheetUploadParams {
  shiftId: string;
}

export function useNonInstantPayTimesheetUpload(params: UseNonInstantPayTimesheetUploadParams) {
  const { shiftId } = params;

  const {
    mutateAsync: uploadToS3,
    isLoading: isUploading,
    isError: isUploadError,
    isSuccess: isUploadSuccess,
  } = useUploadShiftTimecardToS3({
    meta: {
      userErrorMessage: "Failed to upload timesheet. Please try again.",
    },
  });

  const {
    mutateAsync: updateTimecard,
    isLoading: isSubmitting,
    isError: isSubmitError,
    isSuccess: isSubmitSuccess,
  } = useUpdateShiftTimecard();

  const uploadTimesheet = useCallback(
    async (photoBase64: string) => {
      if (!isDefined(shiftId)) {
        return;
      }

      const fileBlob = await base64ToBlob(photoBase64);

      const timecard = await uploadToS3({
        shiftId,
        type: fileBlob.type,
        fileBlob,
      });

      await updateTimecard({
        timecard: [timecard],
        shiftId,
      });
    },
    [shiftId, uploadToS3, updateTimecard]
  );

  return {
    uploadTimesheet,
    isLoading: isUploading || isSubmitting,
    isError: isUploadError || isSubmitError,
    isSuccess: isUploadSuccess && isSubmitSuccess,
  };
}
